export const recalculateAllRecipeNutrients = () => {
  return async (dispatch, getState, MPWWebApi) => {
    await MPWWebApi.postGenericInsertUpdate(
      'Recipe/WriteRecalculateRecipeNutrients'
    );
  };
};

export const resetVerification = () => {
  return async (dispatch, getState, MPWWebApi) => {
    await MPWWebApi.postGenericInsertUpdate(
      'Verification/Reset'
    );
  };
};



// WEBPACK FOOTER //
// ./src/common/SupportTools/state/actions.js